<template>
<span>
    <div class="popover__overlay" v-if="confirmationModal" @click="confirmationModal = false"></div>
    <el-popover
        :disabled="this.room._id === this.currentRoom._id && !linksVisible"
        placement="right"
        v-model="confirmationModal"
        :visible-arrow="false"
        @after-leave="resetPopovers"
        :class="[linksVisible? 'links-popup': '']"
        trigger="manual"
    >
        <div class="popover shared-links" v-if="linksVisible">
            <div class="popover__header">
                <h3>Shared Links</h3>
                <div @click="resetPopovers">
                    <IconBase
                        :height="24"
                        :width="24"
                        :view-box="`0 0 24 24`"
                        :fill="'#E7E6FA'"
                    >
                        <IconCross />
                    </IconBase>
                </div>
            </div>
            <div class="links">
                <div v-for="link in getSharedLinks(room._id)" :key="link" class="link-item">
                    <SharedLink :link="link" />
                </div>
            </div>
        </div>
        <div class="popover switch-room" v-else-if="showSwitchRoomWindow">
            <div class="popover__header">
                <h3>Join {{room.parent ? 'Room - ' : '- Lobby ?'}} {{room.parent ? room.name + ' ?' : ''}} </h3>
                <div @click="resetPopovers">
                    <IconBase
                        :height="24"
                        :width="24"
                        :view-box="`0 0 24 24`"
                        :fill="'#E7E6FA'"
                    >
                        <IconCross />
                    </IconBase>
                </div>
            </div>
            <p>Are you sure you want to exit the current room and join {{room.parent ? room.name : 'Lobby'}}?</p>
            <div style="text-align: right; margin: 0">
                <el-button @click="resetPopovers" type="default">Cancel</el-button>
                <el-button @click="changeRoom" type="primary">Confirm</el-button>
            </div>
        </div>

        <div slot="reference" class="room-details" @click="openSwitchRoomWindow">
            <div class="room-details__top">
                <IconBase
                    v-if="room.isLocked"
                    :height="16"
                    :width="16"
                    :view-box="`0 0 16 16`"
                    :fill="'#E7E6FA'"
                >
                    <IconLockSmall />
                </IconBase>
                <IconBase
                    v-if="room.password"
                    :height="16"
                    :width="16"
                    :view-box="`0 0 25 25`"
                    :fill="'#E7E6FA'"
                    style="margin-bottom: -5px;"
                >
                    <IconKey />
                </IconBase>
                <div class="room-name" :class="{ 'active-room-name' : room._id === currentRoom._id }">
                    {{room.parent ? room.name : 'Lobby'}}
                </div>
                <div v-if="hasSharedLinks(room._id)" class="white-board" :class="{'active': linksVisible}">
                    <span @click="showLinks">
                        <IconBase
                            :height="24"
                            :width="24"
                            :view-box="`0 0 24 24`"
                            :fill="'#50C6DF'"
                        >
                            <IconLinkSmall />
                        </IconBase>
                    </span>
                </div>
            </div>
            <div class="room-details__middle">
                <div class="room-topic" :class="{ 'active-room-topic' : room._id === currentRoom._id }">
                    &nbsp;{{room.topic}}&nbsp;
                </div>
                <div class="pdx-8">
                    <IconBase
                        v-if="isNeedHelp(room._id)"
                        :height="16"
                        :width="16"
                        :view-box="`0 0 16 16`"
                        :fill="'#FDDD46'"
                        style="margin-bottom: -5px; background: '#FDDD46'"
                    >
                        <IconHelp />
                    </IconBase>
                </div>
            </div>
            <div class="room-details__bottom">
                <el-tooltip
                    effect="dark"
                    :content="participantsNames"
                    :disabled="!this.$store.state.user.controls['SEE_PARTICIPANTS_NAMES'] || participantsNames.length==0 || this.$store.state.mainRoomConfig.currentRoom.hideUserNames"
                    placement="bottom"
                >
                    <div class="room-participantcount">
                            <IconBase
                                :height="16"
                                :width="16"
                                :view-box="`0 0 16 16`"
                                :fill="'#E7E6FA'"
                                :class="{'blink-participant': room.foundBy=='participant'}"
                            >
                                <IconPerson />
                            </IconBase>
                        <div class="participant-count__number">
                            <span>{{ room.participants.length }} </span>
                            <span v-if="room.parent">/
                                <!-- //room.lastN?
                                //:room.normalRoomParticipantsLimit -->
                                {{
                                room.expandedRoomParticipantsLimit
                                }}</span>
                        </div>
                    </div>
                </el-tooltip>
                <div class="timer__parent">
                    <TimerClock v-if="this.room.timer" :propagate-event="!this.room.parent" :timer="this.room.timer"></TimerClock>
                </div>
            </div>
            <span class="mobile-icons" v-if="!restrictControlsForAnonymousUsers && room._id === currentRoom._id">
                <Lock class="lock-icon" v-if="controls['ADD_PASSWORD_LOCK']"/>
                <Key class="key-icon" :current-room="room" v-if="controls['ADD_PASSWORD_LOCK']"/>
                <Share class="share-room-icon" />
            </span>
        </div>
    </el-popover>
    <Password v-if="passwordFormVisibility" :room="room" :on-success="onPasswordValid" :on-failure="onPasswordNotValid"/>
</span>
</template>

<script>
import TimerClock from "../timer/TimerClock"
import Icon from 'vue-awesome/components/Icon'
import Password from "./Password";
import {
    mapState,
    mapGetters
} from 'vuex'
import IconBase from '../IconBase'
import IconPerson from '../icons/IconPerson'
import IconLockSmall from '../icons/IconLockSmall'
import IconLinkSmall from '../icons/IconLinkSmall'
import IconCross from '../icons/IconCross'
import IconKey from '../icons/IconKey';
import IconHelpSmall from '../icons/IconHelpSmall'
import SharedLink from './SharedLink'
import Lock from "./Lock";
import Key from "./Key";
import Share from "./Share";
import { JITSI_CONSTANTS } from "../../utils";


export default {
    name: 'Room',
    props: ['room'],
    components: {
        TimerClock,
        // eslint-disable-next-line vue/no-unused-components
        Icon,
        Password,
        IconBase,
        IconPerson,
        IconLockSmall,
        IconLinkSmall,
        IconCross,
        IconKey,
        IconHelp: IconHelpSmall,
        SharedLink,
        Lock,
        Key,
        Share,
    },

    data: function() {
        return {
            confirmationModal: false,
            passwordFormVisibility: false,
            linksVisible: false,
            showSwitchRoomWindow: false
        }
    },
    computed: {
        ...mapState({
            currentRoom: (state) => state.rooms.currentRoom,
            restrictControlsForAnonymousUsers: state => state.mainRoomConfig.currentRoom.restrictControlsForAnonymousUsers && !state.user.profile.loggedIn,
            controls: state => state.user.controls,
        }),
        ...mapGetters('rooms', {
            hasSharedLinks: 'hasSharedLinks',
            isNeedHelp: 'getNeedHelp',
            getSharedLinks: 'getSharedLinks',
            joinRoom: 'joinRoom'
        }),
        participantsNames(){
            const noOfParticipantToShow=10;
            const participantsList = this.room.participants.map(p=>p.displayName || JITSI_CONSTANTS.defaultDisplayName);
            const firstN = participantsList.slice(0,noOfParticipantToShow).join("\n");
            const countsExceptFirstN = participantsList.slice(noOfParticipantToShow).length;
            const countsExceptFirstNString=countsExceptFirstN>0 ? `\nand ${countsExceptFirstN} other${countsExceptFirstN>1?'s':''}` : "";
            return firstN + countsExceptFirstNString;
        }
    },

    methods: {
        showLinks(event) {
            event.stopPropagation() // to prevent 'change room popup' from appearing
            this.confirmationModal = true
            this.linksVisible = true
        },
        openSwitchRoomWindow(){
            if(this.room._id === this.currentRoom._id) return;
            this.confirmationModal = true
            this.showSwitchRoomWindow = true
        },
        resetPopovers() {
            this.confirmationModal = false
            this.linksVisible = false
            this.showSwitchRoomWindow = false
        },
        onPasswordValid: function() {
            this.passwordFormVisibility = false;
            this.joinRoom(this.room);
        },

        onPasswordNotValid: function() {
            this.passwordFormVisibility = false;
        },

        changeRoom: function() {
            this.confirmationModal = false;
            if (this.room.password) {
                this.passwordFormVisibility = true;
            } else {
                this.joinRoom(this.room);
            }
        },
    },
};
</script>

<style scoped>
.el-container {
    height: 100%;
    width: 100%;
}

.el-footer {
    padding-bottom: 13px;
    position: relative;
    height: fit-content !important;
    vertical-align: center;
}

.room-details {
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 12px;
    position: relative;
}

.room-details__top,
.room-details__middle,
.room-details__bottom{
    display: flex;
    align-items: center;
}

.room-details__top {
    min-height: 30px;
}

.room-details__top,
.room-details__bottom{
    padding: 0 11px;
}

.room-details__middle {
    padding: 0px 8px 10px;
    justify-content: space-between;
}



.room-details__bottom {
    justify-content: space-between;
}

.room-name {
    font-size: 16px;
    line-height: 20px;
}

.timer__parent {
    align-self: flex-start;
    padding-bottom: 0px;
}

.need-help {
    position: absolute;
    right: 4px;
    bottom: -8px;
}

.expand-mode {
    position: absolute;
    right: 115px;
    bottom: -8px;
}

.lock-key-room {
    position: absolute;
    right: 30px;
    bottom: -8px;
}

.password-incorrect,
.password-header {
    margin: -25px !important;
}

.password-footer {
    margin-top: -40px !important;
}

.white-board {
    position: relative;
    text-align: right;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    width: 30px;
}

.white-board:hover,
.white-board.active {
    background: rgba(81, 81, 107, 0.5);
    border-radius: 4px;
}

.room-topic {
    font-size: 12px;
    line-height: 16px;
}

.room-participantcount {
   display: flex;
}

/* .participant-count__number {
    position: absolute;
    right: -10px;
    top: 1px;
} */

.active-room-name {
    color: #f2f6fc;
}

.active-room-topic {
    color: #e4e7ed;
}

.background svg {
    fill: white;
}

.popover__overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vmax;
    background: #000;
    opacity: 0.5;
    z-index: 1;
}

.popover__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.popover__header h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    overflow: hidden;
    height: 23px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.popover p {
    max-width: 91%;
    font-size: 16px;
    line-height: 20px;
    color: #E7E6FA;
    word-break: break-word;
}



.links {
    max-height: 250px;
    overflow-y: auto;
}


>>>button.el-button--default,
>>>button.el-button--default:hover,
>>>button.el-button--primary,
>>>button.el-button--primary:hover {
    width: 78px;
    height: 36px;
    color: #E7E6FA;
    border-radius: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    margin-left: 17px;
}

>>>button.el-button--default,
>>>button.el-button--default:hover {
    border: 1px solid #E7E6FA;
    background: #2A2A3D;
    padding: 8px 12px;
}

>>>button.el-button--primary,
>>>button.el-button--primary:hover {
    border: 1px solid #6F26DF;
    background: #6F26DF;
    padding: 8px;
}
</style>

<style>
.el-popover {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    background: #2A2A3D;
    color: #E7E6FA;
    border: none;
    border-radius: 8px;
    padding: 0 12px;
    width: 320px;
}

@media (max-width: 767px) {
    .el-popover {
        left: 0px !important;
        top: 56px !important;
        right: 0 !important;
        bottom: 0 !important;
        position: fixed !important;
        margin: 0 !important;
        border-radius: 0;
        box-sizing: border-box;
        width: 100%;
    }
}

.popover.switch-room {
    padding: 8px 0 15px 0;
}

.popover__header p {
    margin: 0;
    padding: 20px 0;
}

.el-popover.links-popup {
    width: 427px;
}
.el-tooltip__popper{
    white-space: pre;
    line-height: 20px;
}
.blink-participant{
    animation-name: blink;
    animation-duration: 0.4s;
    animation-iteration-count: 8;
}

.room-name,
.room-topic{
    width: 280px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.pdx-8 {
    padding: 0 8px;
}

.mobile-icons{
    display: none;
    margin-top: auto;
    margin-bottom: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 20px;
}

.mobile-icons .lock-icon, .mobile-icons .key-icon, .mobile-icons .share-room-icon{
    width: 31px;
    display: inline-flex;
    height: 32px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;
    background: #3E3E52;
}

.mobile-icons .lock-icon{
    margin-right: 10px;
    padding: 4px 0 0 9px;
}

.mobile-icons .key-icon{
    margin-right: 10px;
    padding: 10px 0 0 1px;
}
.mobile-icons .share-room-icon{
    padding: 6px 0 0 6px;
}

@media (max-width: 767px){
    .mobile-icons{
        display: inline-flex;
        align-items: end;
        justify-content: center;
        top: auto;
        bottom: 22px;
    }
    .room-name,
    .room-topic{
        width: 220px;
    }
    .active_room .room-name {
        width: 100%;
    }
    .active_room .room-topic{
        width: 110px;
    }
    .mobile-icons{
        right: 5px;
    }
    .mobile-icons .lock-icon, .mobile-icons .key-icon, .mobile-icons .share-room-icon{
        widows: 27px;
        height: 28px;
    }
    .mobile-icons .lock-icon{
        margin-right: 5px;
    }

    .mobile-icons .key-icon{
        margin-right: 5px;
    }
    .pdx-8 {
        padding: 0;
        margin-top: -58px;
    }
    .white-board {
        margin-top: -10px;
        margin-left: 45px;
        z-index: 10;
        flex: initial;
    }
}
@media (hover: none){
    .mobile-icons{
        display: inline-flex;
        align-items: end;
        justify-content: center;
        top: auto;
        bottom: 22px;
    }
    .room-name,
    .room-topic{
        width: 220px;
    }
    .active_room .room-name {
        width: 100%;
    }
    .active_room .room-topic{
        width: 110px;
    }
    .mobile-icons{
        right: 5px;
    }
    .mobile-icons .lock-icon, .mobile-icons .key-icon, .mobile-icons .share-room-icon{
        widows: 27px;
        height: 28px;
    }
    .mobile-icons .lock-icon{
        margin-right: 5px;
    }

    .mobile-icons .key-icon{
        margin-right: 5px;
    }
    .pdx-8 {
        padding: 0;
        margin-top: -58px;
    }
    .white-board {
        margin-top: -10px;
        margin-left: 45px;
        z-index: 10;
        flex: initial;
    }
}

@keyframes blink {
    from {
        fill: #8331ff;
    }
    to {
        fill: #50c6df;
    }
}
</style>
